import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/logo_vertical.svg'


const _withScopeId = n => (_pushScopeId("data-v-c106c64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-header" }
const _hoisted_2 = {
  key: 0,
  class: "server-date"
}
const _hoisted_3 = { class: "page-header-main container" }
const _hoisted_4 = { class: "page-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-small",
  src: _imports_1
}, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "app-name"
}
const _hoisted_8 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_AccountInfoPanel = _resolveComponent("AccountInfoPanel")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (this.env.length > 0 && !_ctx.isToday && _ctx.showDateTip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$formatDate(_ctx.displayDate)) + " ", 1),
          _createElementVNode("i", {
            class: "fal fa-times ml-3",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.showDateTip = false)),
            style: {"cursor":"pointer"}
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        (_ctx.appName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.appName), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showAppMenu)
        ? (_openBlock(), _createBlock(_component_AccountInfoPanel, {
            key: 0,
            isExternal: _ctx.isExternal
          }, null, 8, ["isExternal"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showCancelAlertBox)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = $event => (_ctx.showCancelAlertBox = false))
        }, {
          header: _withCtx(() => [
            _createElementVNode("h3", null, _toDisplayString(_ctx.alertBoxTitle), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", { innerHTML: _ctx.alertBoxBody }, null, 8, _hoisted_8)
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.exitApplication()))
            }, "Yes"),
            _createElementVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.showCancelAlertBox = false))
            }, "No")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}